// Zen Sporty skeleton loaders — used throughout the app
export function SkeletonText({ width = '100%', height = 14, style = {} }) {
  return (
    <div className="skeleton" style={{ width, height, ...style }} />
  );
}

export function SkeletonCard({ rows = 3, style = {} }) {
  return (
    <div className="card" style={style}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <div className="skeleton" style={{ width: 36, height: 36, borderRadius: 10 }} />
        <div style={{ flex: 1 }}>
          <div className="skeleton" style={{ width: '60%', height: 13, marginBottom: 6 }} />
          <div className="skeleton" style={{ width: '40%', height: 11 }} />
        </div>
      </div>
      {/* Rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ marginBottom: i < rows - 1 ? 10 : 0 }}>
          <div className="skeleton" style={{ width: `${75 + Math.random() * 20}%`, height: 13 }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonStatBar() {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 32 }}>
      {[0,1,2,3].map(i => (
        <div key={i} className="card" style={{ padding: '18px 20px', borderTop: '3px solid rgba(255,255,255,0.06)' }}>
          <div className="skeleton" style={{ width: '55%', height: 36, marginBottom: 8, borderRadius: 4 }} />
          <div className="skeleton" style={{ width: '70%', height: 10, marginBottom: 4 }} />
          <div className="skeleton" style={{ width: '45%', height: 9 }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonGameCard() {
  return (
    <div className="glass-hover" style={{ padding: '16px 20px', marginBottom: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div className="skeleton" style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <div className="skeleton" style={{ width: '50%', height: 14, marginBottom: 6 }} />
          <div className="skeleton" style={{ width: '70%', height: 11 }} />
        </div>
        <div className="skeleton" style={{ width: 60, height: 22, borderRadius: 100 }} />
      </div>
    </div>
  );
}

export function SkeletonPlayerRow() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
      <div className="skeleton" style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <div className="skeleton" style={{ width: '40%', height: 13, marginBottom: 5 }} />
        <div className="skeleton" style={{ width: '25%', height: 10 }} />
      </div>
      <div className="skeleton" style={{ width: 50, height: 22, borderRadius: 100 }} />
    </div>
  );
}

// Full page spinner (zen minimal)
export function PageSpinner({ label = '' }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '60vh', gap: 16,
    }}>
      {/* Ice crystal spinner */}
      <div style={{ position: 'relative', width: 48, height: 48 }}>
        <div className="spinner" style={{ width: 48, height: 48, borderWidth: 3 }} />
        <div style={{
          position: 'absolute', inset: 0, display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: 18,
        }}>🏟</div>
      </div>
      {label && (
        <div style={{
          fontFamily: 'var(--font-display)', fontSize: 11,
          letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-2)',
        }}>{label}</div>
      )}
    </div>
  );
}
